import React from 'react'

const Attachment = () => {
  return (
    <div>Attachment</div>
  )
}

export default Attachment